import i18n from 'i18next';
import { dynamicObjectType } from 'types';
import { nav } from 'utils';
import { create } from 'zustand';
import useAPIStore from '../APIStore';
import useBizLogicStore from '../BizLogicStore';
import useSystemStore from '../SystemStore';
import useUserStore from '../UserStore';

// interface ErrorProps {
// 	code: number;
// 	message?: string | null;
// 	data?: dynamicObjectType;
// }

interface ErrorStates {}

interface ErrorActions {
	actions: {
		showError: (
			code: number,
			message?: string | null,
			data?: dynamicObjectType
		) => void;
		handleWebscanError: (code: number) => void;
		handleSDKScanError: (error: dynamicObjectType) => Promise<void>;
		handleQueryError: (res: dynamicObjectType) => void;
	};
}

const useErrorStore = create<ErrorStates & ErrorActions>((set, get) => ({
	actions: {
		showError: (code, message, data) => {
			nav('/Error', {
				replace: true,
				state: {
					error: {
						code: code,
						message: message,
						data: data,
					},
				},
			});
		},
		handleWebscanError: (code) => {
			let msg = 'app.error.unknown';
			const authMode = useSystemStore.getState().authMode;
			const sysInfo = useSystemStore.getState().sysInfo;
			const cameraInfo = useSystemStore.getState().cameraInfo;
			switch (code) {
				case 42100:
					if (authMode === 0) {
						msg =
							i18n.t('app.notsupport.video1') +
							cameraInfo!.maxPreviewWidth +
							'x' +
							cameraInfo!.maxPreviewHeight +
							i18n.t('app.notsupport.video2');
					} else if (authMode === 1) {
						if (
							sysInfo!.equipmentPlatform === 'mobile' &&
							((sysInfo!.equipmentOS === 'iOS' &&
								sysInfo!.equipmentBrowser ===
									'Mobile Safari') ||
								(sysInfo!.equipmentOS === 'Android' &&
									sysInfo!.equipmentBrowser === 'Chrome'))
						) {
							msg = 'app.notsupport.device';
						} else if (
							sysInfo!.equipmentPlatform === 'mobile' &&
							((sysInfo!.equipmentOS === 'iOS' &&
								sysInfo!.equipmentBrowser !==
									'Mobile Safari') ||
								(sysInfo!.equipmentOS === 'Android' &&
									sysInfo!.equipmentBrowser !== 'Chrome'))
						) {
							msg = 'app.notsupport.browser';
						} else {
							msg = 'app.notsupport.os';
						}
					} else {
						msg = 'app.notsupport.os';
					}
					break;
			}
			get().actions.showError(code, msg);
		},
		handleSDKScanError: async (error) => {
			const torchAvailability =
				useSystemStore.getState().torchAvailability;
			const product = useBizLogicStore.getState().product;
			const gift = useBizLogicStore.getState().giftMode;
			const currentReqUAID = product ? product.currentReqUAID : undefined;
			//let uaidType = product?product.uaidType:undefined;
			const authenticationId = product
				? product.authenticationId
				: undefined;
			console.log('authenticationId -> ' + authenticationId);
			const challengeCode = product ? product.challengeCode : undefined;
			console.log('challengeCode -> ' + challengeCode);

			let errorMsg = '';
			let errorData = {};
			let basicInfo: dynamicObjectType;
			switch (error.code) {
				case 902:
					errorMsg = 'verify.warning.interrupt';
					break;
				case 905:
					errorMsg = 'verify.warning.termination';
					break;
				case 907:
					errorMsg = 'error.timeout';
					break;
				case 910:
					errorMsg = torchAvailability
						? 'verify.warning.darkTorch'
						: 'verify.warning.dark';
					break;
				case 931:
				case 932:
				case 933:
				case 934:
					errorMsg = 'verify.warning.undetect' + error.code;
					errorData = { displayImage: error.data };
					break;
				case 971: //QR code
					console.log("It's QR code");

					if (gift) {
						const res = await useAPIStore
							.getState()
							.api.authenticateUAID(
								error.data.QRText,
								null,
								null,
								null,
								null,
								true
							);
						if (res.code !== '0' || !res.data) {
							get().actions.handleQueryError(res);
							// get().actions.showError(
							// 	res.code,
							// 	useSystemStore
							// 		.getState()
							// 		.actions.resolveMultiLang(res.message)
							// );
							return;
						}
						const verifyStatus =
							res.data.authMessageExt.verifyStatus;
						const uaidInfo = res.data.uaid;
						const layerType = uaidInfo.specs.layers.filter(
							(layer: dynamicObjectType) => {
								return (
									layer.layerNumber ===
									uaidInfo.layerNumberInSpecs
								);
							}
						)[0].type;
						console.log('layerType: ' + layerType);
						if ([2, 4, 5, 6].indexOf(layerType) === -1) {
							//	Gift for exposed, package, single layer code is not applicable
							get().actions.showError(
								42101,
								'error.gift.invalid.code'
							);
							return;
						}
						if (res.data.recallInfo.length > 0) {
							//	Gift for recalled code is not applicable
							const arr = res.data.recallInfo.filter(
								(item: any) => item.ended === true
							);
							const msgCode =
								res.data.authenticationMessage?.code;
							if (
								arr.length > 0 ||
								msgCode === 'msg_code_recalled_fail'
							) {
								get().actions.showError(
									42102,
									'error.gift.recall.ended.code'
								);
							} else {
								get().actions.showError(
									42103,
									'error.gift.recall.code'
								);
							}
							return;
						}
						if ([3, 4].indexOf(verifyStatus) === -1) {
							//	Not the owner of the code, either code is not claimed or claimed by others.
							get().actions.showError(
								42104,
								'error.gift.not.owner'
							);
							return;
						}
						useBizLogicStore
							.getState()
							.actions.handleQueryResponse(res);
						return;
					}

					//if (error.data.UAIDType === 4) {
					if (challengeCode === '2') {
						console.log(
							'detect the previous one is authorization code ....'
						);
						//special handling for verify authorization code hidden layer
						useBizLogicStore
							.getState()
							.actions.handleQueryResponse(
								await useAPIStore
									.getState()
									.api.authenticateUAID(
										currentReqUAID,
										null,
										authenticationId,
										challengeCode,
										error.data.UAIDCode,
										false
									)
							);
						return;
					}
					useBizLogicStore
						.getState()
						.actions.handleQueryResponse(
							await useAPIStore
								.getState()
								.api.authenticateUAID(
									error.data.UAIDCode,
									null,
									null,
									null,
									null,
									false
								)
						);
					return;
				case 972:
				case 974:
				case 979:
					errorMsg = 'error.lackOfAccessPriv';
					break;
				case 981:
				case 982:
				case 983:
					errorMsg = 'error.server';
					break;
				case 976: //UAID is not activated or not bound
				case 977: //uaid is disabled
				case 978: //UAID expired
				case 985: //UAID is void
					useBizLogicStore.getState().actions.handleQueryResponse(
						await useAPIStore.getState().api.authenticateUAID(
							error.data.QRText,
							null,
							null,
							null,
							null,
							true //-->enable this is in order to get whether the code is not activated or not bind, if set to false AR code need the image data
						)
					);
					return;
				case 984: //Hidden code is used
					console.log('Hidden code is used');
					let signature = null;
					if (!useUserStore.getState().userInfo) {
						let ownershipCardInfo = localStorage.getItem(
							error.data.UAIDCode
						);
						signature = ownershipCardInfo
							? JSON.parse(ownershipCardInfo).signature
							: null;
					}

					if (challengeCode === '2') {
						console.log(
							'detect the previous one is authorization code ....'
						);
						//special handling for verify authorization code hidden layer
						useBizLogicStore
							.getState()
							.actions.handleQueryResponse(
								await useAPIStore
									.getState()
									.api.authenticateUAID(
										currentReqUAID,
										signature,
										authenticationId,
										challengeCode,
										error.data.UAIDCode,
										true
									)
							);
						return;
					}

					//handleQueryResponse(await authenticateUAID(error.data.UAIDCode, signature, null, null, null))
					await useAPIStore
						.getState()
						.api.authenticateUAID(
							error.data.UAIDCode,
							signature,
							null,
							null,
							null,
							true
						)
						.then((res) => {
							useBizLogicStore
								.getState()
								.actions.handleQueryResponse(res);
						})
						.catch((error) => {
							let errorObject = JSON.parse(error.message);
							get().actions.showError(
								errorObject.code,
								errorObject.message
							);
						});
					return;
				case 973:
					errorMsg = 'verify.warning.invalid';
					break;
				case 996: //scanner time out
					// errorMsg = 'error.timeout';
					nav('/Timeout');
					return;
				case 999:
					return;
				/*
				default:
					errorMsg = 'error.other';
					break;
				*/
				default:
					errorMsg = error.message[i18n.resolvedLanguage];
					break;
			}
			get().actions.showError(error.code, errorMsg);
		},
		handleQueryError: (res) => {
			const resCode = parseInt(res.code);
			let errorMsg = '';
			switch (resCode) {
				case 170015:
					window.location.href = res.data;
					return;
				// case 170012:
				// 	errorMsg = 'verify.notbinded';
				// 	break;
				// case 170016:
				// 	errorMsg = 'verify.notactivated';
				// 	break;
				// case 170017:
				// 	errorMsg = 'verify.disabled';
				// 	break;
				// case 170026:
				// 	errorMsg = 'verify.expired';
				// 	break;
				// case 100006:
				// 	errorMsg = 'error.lackOfAccessPriv';
				// 	break;
				// case 100002:
				// case 170035:
				// 	//	170035: verify arcode as qrcode, skip logic as it's not reachable
				// 	errorMsg = 'app.error.unknown';
				// 	break;
				case 1004016:
					errorMsg = 'verify.notactivated';
					break;
				case 1004012:
					errorMsg = 'verify.notbinded';
					break;
				case 1004026:
					errorMsg = 'verify.expired';
					break;
				case 1004017:
					errorMsg = 'verify.disabled';
					break;
				case 1004038:
					errorMsg = 'verify.isVoid';
					break;
				default:
					errorMsg = res.message[i18n.resolvedLanguage];
					break;
			}
			get().actions.showError(resCode, errorMsg);
		},
	},
}));

export const useErrorActions = () => useErrorStore((state) => state.actions);

export default useErrorStore;
